/**
 * The overtime recorded on this trip, as the API last returned it
 * (`driver_overtime`): one row per entry — where
 * (Felvételnél / A célnál), how (Időzítve / Utólag jelentve), the minutes and
 * the driver's note — and the total. A timer that is still open reads "Fut",
 * not minutes: it has none until it is closed. Every other entry shows where
 * the office's review stands, the way a receipt does (Beküldve / Elfogadva /
 * Elutasítva).
 *
 * Minutes only — never money.
 */
import React from 'react';
import { OVERTIME_COPY } from '../portalFormat';
import {
  entryMinutes, isRunningTimer, overtimeEntries, overtimeTotalMinutes,
} from '../../../Utils/driverOvertime';
import { ClockIcon } from './Icons';

/** `copy` names everything: the driver's Hungarian by default (OVERTIME_COPY). */
export default function OvertimeCard({ trip, copy = OVERTIME_COPY }) {
  const entries = overtimeEntries(trip.driver_overtime);
  if (!entries.length) return null;

  return (
    <section className="pp-card pp-overtime" aria-label={copy.title} data-testid="portal-overtime">
      <div className="pp-overtime__head">
        <ClockIcon size={16} />
        <span className="pp-eyebrow">{copy.title}</span>
      </div>
      <ul className="pp-overtime__list">
        {entries.map((entry, index) => {
          const running = isRunningTimer(entry);
          const minutes = entryMinutes(entry);
          const where = copy.stages[entry.stage] || copy.title;
          const how = copy.methods[entry.method] || '';
          return (
            // Entries have no id in the payload; their order is the identity.
            // eslint-disable-next-line react/no-array-index-key
            <li className="pp-overtime__row" key={`${entry.stage}-${entry.method}-${index}`} data-testid="portal-overtime-entry">
              <span className="pp-overtime__body">
                <span className="pp-overtime__title">{where}</span>
                <span className="pp-overtime__meta">{how}</span>
                {entry.note ? <span className="pp-overtime__note">{entry.note}</span> : null}
              </span>
              {running ? (
                <span className="pp-badge pp-badge--live">{copy.running}</span>
              ) : (
                <span className="pp-overtime__side">
                  <span className="pp-overtime__minutes">{copy.minutes(minutes)}</span>
                  {entry.review_status && copy.status ? (
                    <span
                      className={`pp-badge pp-badge--${copy.status(entry.review_status).tone}`}
                      data-testid="portal-overtime-status"
                    >
                      {copy.status(entry.review_status).label}
                    </span>
                  ) : null}
                </span>
              )}
            </li>
          );
        })}
      </ul>
      <div className="pp-overtime__total" data-testid="portal-overtime-total">
        {copy.total(overtimeTotalMinutes(entries))}
      </div>
    </section>
  );
}
